import { render, staticRenderFns } from "./CharacterIconSizeInput.vue?vue&type=template&id=31102406&lang=pug&"
import script from "./CharacterIconSizeInput.vue?vue&type=script&lang=ts&"
export * from "./CharacterIconSizeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterIconSizeInput.vue"
export default component.exports